import {
  DeleteFilled,
  DeleteRowOutlined,
  PlayCircleOutlined,
  PlusCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Col,
  ConfigProvider,
  Form,
  FormInstance,
  Row,
  Segmented,
  Collapse,
  Divider,
  message,
  Tabs,
  Radio,
  Space,
  Table,
  Checkbox,
  Image,
  Avatar,
} from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import SearchInput from "../../../components/Input/SearchInput";
import Select from "../../../components/Select/Select";
import TableContainer from "../../../components/Table/TableContainer";
import Text from "../../../components/Text/Text";
import {
  createStep3,
  deleteProductShop,
  getDataStep3,
} from "../../../datasource/AchievementDataSource";
import { getZones } from "../../../datasource/CustomerDatasource";
import { getProductGroup } from "../../../datasource/ProductDatasource";
import { mapStatusEdit } from "../../../definitions/achievementStatus";
import { ProductEntity } from "../../../entities/PoductEntity";
import { ProductGroupEntity } from "../../../entities/ProductGroupEntity";
import { StoreEntity } from "../../../entities/StoreEntity";
import { color } from "../../../resource";
import image from "../../../resource/image";
import { numberFormatter } from "../../../utility/Formatter";
import { ModalSelectedProduct } from "../../Shared/ModalSelecteProduct";
import { ModalSelectStore } from "../../Shared/ModalSelectStore";
import { AchievementTabCardContainer } from "../StyleCSS";

interface Props {
  key: number;
  form3: FormInstance;
  achievementId: string;
  achievementRewardId: string;
  setDisableStep: any;
  status: string;
  isApproved: boolean;
}

function AchievementStep3({
  key,
  form3,
  achievementId,
  achievementRewardId,
  setDisableStep,
  status,
  isApproved,
}: Props) {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [activeTab, setActiveTabs] = useState<any>("SHOP");
  const [openStore, setOpenStore] = useState<boolean>(false);
  const [openProduct, setOpenProduct] = useState<boolean>(false);

  const [sumCount, setSumCount] = useState<{
    countProduct: number;
    countShop: number;
    customerType: string;
  }>();

  const [selectedProd, setSelectedProd] = useState<ProductEntity[]>([]);
  const [searchProd, setSearchProd] = useState<ProductEntity[]>([]);

  const [selectedShop, setSelectedShop] = useState<StoreEntity[]>([]);
  const [searchShop, setSearchShop] = useState<StoreEntity[]>([]);
  const [productGroup, setProductGroup] = useState<ProductGroupEntity[]>([]);
  const [zoneList, setZoneList] = useState<any>();

  const [searchText, setSearchText] = useState<any>(undefined);
  const [zone, setZone] = useState<any>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const getData = async () => {
    setLoading(true);
    setIsEdit(mapStatusEdit(status, isApproved));
    await getDataStep3({
      achievementId: achievementId,
      type: activeTab,
      page: 0,
      take: 0,
      searchText,
      zone,
    }).then((res) => {
      setDisableStep(res.summary.countProduct > 0 && res.summary.countShop > 0 ? false : true);
      setSelectedShop([]);
      setSearchShop([]);
      setSumCount(res.summary);
      if (activeTab === "SHOP") {
        form3.setFieldsValue({ customerType: res?.summary?.customerType || "DEALER" });
        form3.setFieldsValue({
          achievementShop: res?.data?.map((e) => ({
            achievementShopId: e.achievementShopId,
            customerCompanyId: e.customerCompanyId,
            customerType: form3.getFieldValue("customerType"),
            customerName: e.customerName,
            customerNo: e.customerNo,
            customerZone: e.customerZone,
            customerGroupName: e.customerGroupName,
            isActive: e.isActive,
            achievementId: achievementId,
            achievementRewardId: achievementRewardId,
          })),
        });
        const mapDataShop = res?.data?.map((x) => {
          const data: any = {};
          const findChecked = selectedShop?.find(
            (y) => y.customerCompanyId === x.customerCompanyId,
          );
          data.customerCompanyId = x.customerCompanyId;
          data.customerName = x.customerName;
          data.customerNo = x.customerNo;
          data.customerType = x.customerType;
          data.zone = x.customerZone;
          data.isChecked = findChecked ? findChecked.isChecked : false;

          return data;
        });
        res?.summary?.countShop === res?.data?.length && setSelectedShop(mapDataShop);
        setSearchShop(mapDataShop);
        setLoading(false);
      } else {
        form3.setFieldsValue({
          achievementProduct: res.data.map((e) => ({
            achievementProductId: e.achievementProductId,
            productId: e.productId,
            productName: e.productName,
            productCode: e.productCode,
            productGroup: e.productGroup,
            saleUom: e.saleUom,
            saleUomTh: e.saleUomTh,
            isActive: e.isActive,
            achievementId: achievementId,
            achievementRewardId: achievementRewardId,
          })),
        });
        const mapDataProd = res.data.map((x) => {
          const findChecked = selectedProd?.find((y) => `${y.productId}` === `${x.productId}`);
          const data: any = {};
          data.productId = x.productId;
          data.productImage = x.imageProduct;
          data.commonName = x.commonName;
          data.productCodeNAV = x.productCode;
          data.packSize = x.packSize;
          data.productName = x.productName;
          data.marketPrice = x.marketPrice;
          data.unitPrice = x.unitPrice;
          data.saleUOMTH = x.saleUomTh;
          data.baseUOM = x.saleUom;
          data.productStrategy = x.productStrategy;
          data.productGroup = x.productGroup;
          data.productBrandId = x.productBrandId;
          data.isChecked = findChecked ? findChecked.isChecked : false;
          data.isDisable = true;
          return data;
        });
        res?.summary?.countProduct === res?.data?.length && setSelectedProd(mapDataProd);
        setSearchProd(mapDataProd);
        setLoading(false);
      }
    });
  };
  const deleteList = async () => {
    const f3 = form3.getFieldsValue(true);
    let comfirmDeleteShop = [null];
    let comfirmDeleteProduct = [null];
    if (activeTab === "SHOP") {
      const shopChecked = selectedShop.filter((x) => x.isChecked);
      comfirmDeleteShop = shopChecked.map((s) => {
        const find = f3.achievementShop.find((f) => f.customerCompanyId === s.customerCompanyId);
        if (find) {
          return find.achievementShopId;
        }
      });
    } else {
      const prodChecked = selectedProd.filter((x) => x.isChecked);
      comfirmDeleteProduct = prodChecked.map((p) => {
        const find = f3.achievementProduct.find((f) => f.productId === p.productId);
        if (find) {
          return find.achievementProductId;
        }
      });
    }
    await deleteProductShop({
      achievementShopId: comfirmDeleteShop,
      achievementProductId: comfirmDeleteProduct,
    }).then((res) => {
      if (res.success) {
        getData();
      }
    });
  };
  const fetchProductGroup = async () => {
    const getProdGroup = await getProductGroup(userProfile.company);
    setProductGroup(
      getProdGroup.responseData.map((d: any, index: number) => ({ ...d, key: index })),
    );
  };
  const fetchZone = async () => {
    const getZone = await getZones(userProfile.company);
    setZoneList(getZone);
  };

  useEffect(() => {
    getData();
    fetchProductGroup();
    fetchZone();
    form3.setFieldsValue({
      customerType: "DEALER",
      achievementShop: [null],
      achievementProduct: [null],
    });
  }, [activeTab, searchText, zone]);

  const tabList = [
    { label: `ร้านค้า`, key: "SHOP" },
    {
      label: `สินค้า`,
      key: "PRODUCT",
    },
  ];

  const storeComponent = () => {
    const checkDisable = ((selectedShop || [])?.filter((x) => x.isChecked)?.length || 0) > 0;

    const callBackShop = async (item: StoreEntity[]) => {
      item = item.map((p: any) => ({ ...p, isChecked: false }));
      const mapDataShop = [...selectedShop.filter((x) => !x.isChecked), ...item];
      setSelectedShop(mapDataShop);
      setSearchShop(mapDataShop);

      const f3 = form3.getFieldsValue(true).achievementShop;
      const mapData = mapDataShop.map((i) => {
        const data: any = {};
        const findId = f3.find((f) => f.customerCompanyId === i.customerCompanyId);
        if (findId) {
          data.achievementShopId = findId.achievementShopId;
        }
        data.customerCompanyId = i.customerCompanyId;
        data.customerType = form3.getFieldValue("customerType");
        data.customerName = i.customerName;
        data.customerNo = i.customerNo;
        data.customerZone = i.zone;
        data.customerGroupName = i.customerGroupName;
        data.isActive = i.isActive;
        data.achievementId = achievementId;
        data.achievementRewardId = achievementRewardId;

        return data;
      });
      await createStep3({ achievementShop: mapData, achievementProduct: [] }).then((res) => {
        getData();
      });
      setOpenStore(!openStore);
    };
    const handleCheckBoxDelete = (e: any, cusId: string) => {
      const mapCheckSearch = searchShop.map((item) =>
        _.set(
          item,
          "isChecked",
          item.customerCompanyId === cusId ? e.target.checked : item.isChecked,
        ),
      );
      const mapCheckBoxed = selectedShop.map((item) =>
        _.set(
          item,
          "isChecked",
          item.customerCompanyId === cusId ? e.target.checked : item.isChecked,
        ),
      );
      setSearchShop(mapCheckSearch);
      setSelectedShop(mapCheckBoxed);
    };
    const handleAllCheckBoxDelete = (e: any) => {
      const checkBoxed = searchShop.map((item) => ({ ...item, isChecked: e.target.checked }));
      const mapData = searchShop.map((item) => {
        const findObj = checkBoxed.find((el) => el.customerCompanyId === item.customerCompanyId);
        if (findObj) {
          return { ...item, isChecked: e.target.checked };
        }
        return { ...item, isChecked: item.isChecked };
      });
      setSearchShop(mapData);

      const mapCheckBoxed = searchShop.map((item) => ({ ...item, isChecked: e.target.checked }));
      const mapSelecedData = selectedShop.map((item) => {
        const findObj = mapCheckBoxed.find((el) => el.customerCompanyId === item.customerCompanyId);
        if (findObj) {
          return { ...item, isChecked: e.target.checked };
        }
        return { ...item, isChecked: item.isChecked };
      });
      setSelectedShop(mapSelecedData);
    };
    const columes = [
      {
        title: selectedShop?.length > 0 && (
          <Checkbox
            onClick={(e) => handleAllCheckBoxDelete(e)}
            checked={searchShop.every((x) => x.isChecked)}
          />
        ),
        width: "5%",
        hidden: isEdit,
        render: (text: string, value: any) => (
          <Checkbox
            onClick={(e) => handleCheckBoxDelete(e, value.customerCompanyId)}
            checked={value.isChecked}
          />
        ),
      },
      {
        title: "รหัสร้านค้า",
        dataIndex: "customerNo",
        key: "customerNo",
        render: (value: any, row: any, index: number) => {
          return {
            children: <Text>{value}</Text>,
          };
        },
      },
      {
        title: "ชื่อร้านค้า",
        dataIndex: "customerName",
        key: "customerName",
        render: (value: any, row: any, index: number) => {
          return {
            children: <Text>{value}</Text>,
          };
        },
      },
      {
        title: "ประเภทคู่ค้า",
        dataIndex: "customerType",
        key: "customerType",
        render: (value: any, row: any, index: number) => {
          return {
            children: <Text>{value || form3.getFieldValue("customerType")}</Text>,
          };
        },
      },
      {
        title: "เขตการขาย",
        dataIndex: "zone",
        key: "zone",
        render: (value: any, row: any, index: number) => {
          return {
            children: <Text>{value}</Text>,
          };
        },
      },
    ].filter((item) => !item.hidden);

    return (
      <div style={{ padding: "20px" }}>
        <Row style={{ paddingBottom: "10px" }}>
          <Form.Item name='customerType'>
            <Radio.Group defaultValue={"DEALER"} disabled={sumCount?.customerType ? true : false}>
              <Space>
                <Radio value={"DEALER"}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    Dealer
                  </Text>
                </Radio>
                <Radio value={"SUB_DEALER"}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    Sub-dealer
                  </Text>
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row justify={"space-between"} gutter={8}>
          <Col span={5}>
            <SearchInput
              placeholder='รหัส/ชื่อร้านค้า'
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Col>
          <Col span={5}>
            <Select
              placeholder='เขตทั้งหมด'
              data={zoneList?.map((z) => ({ label: z.zoneName, key: z.zoneName })) || []}
              onChange={(e) => setZone(e)}
              value={zone}
            />
          </Col>
          <Col span={8} />
          <Col span={3}>
            <Button
              typeButton={isEdit ? "disabled" : "border-primary"}
              style={{ cursor: isEdit ? "not-allowed" : "pointer" }}
              title={"เพิ่มร้านค้า"}
              icon={<PlusOutlined style={{ color: color.white }} />}
              onClick={() => !isEdit && setOpenStore(true)}
            />
          </Col>
          <Col span={3}>
            <Button
              style={{ cursor: checkDisable ? "pointer" : "not-allowed" }}
              typeButton={checkDisable ? "danger" : "light-disabled"}
              title={"ลบร้านค้า"}
              icon={<DeleteFilled color={color.white} />}
              onClick={() => checkDisable && deleteList()}
            />
          </Col>
        </Row>
        <br />
        <TableContainer>
          <Table
            loading={loading}
            pagination={false}
            columns={columes}
            dataSource={searchShop || []}
            scroll={{ y: 500 }}
          />
        </TableContainer>
        {openStore && (
          <ModalSelectStore
            company={userProfile.company}
            callBackShop={callBackShop}
            showModalShop={openStore}
            onClose={() => setOpenStore(!openStore)}
            currentSelectShop={selectedShop}
            customerType={form3.getFieldValue("customerType") === "DEALER" ? "DL" : "SD"}
          />
        )}
      </div>
    );
  };

  const productComponent = () => {
    const checkDisable = ((selectedProd || [])?.filter((x) => x.isChecked)?.length || 0) > 0;

    const callBackProduct = async (item: ProductEntity[]) => {
      item = item.map((p: any) => ({ ...p, isChecked: false }));

      const mapDataProd = [...selectedProd.filter((x) => !x.isChecked), ...item];
      setSelectedProd(mapDataProd);
      setSearchProd(mapDataProd);

      const f3 = form3.getFieldsValue(true).achievementProduct;
      const mapData = mapDataProd.map((i) => {
        const data: any = {};
        const findId = f3.find((f) => f.productId === i.productId);
        if (findId) {
          data.achievementProductId = findId.achievementProductId;
        }
        data.productId = i.productId;
        data.productName = i.productName;
        data.productCode = i.productCodeNAV;
        data.productGroup = i.productGroup;
        data.saleUom = i.baseUOM;
        data.saleUomTh = i.saleUOMTH;
        (data.isActive = true), (data.imageProduct = i.productImage);
        data.achievementId = achievementId;
        data.achievementRewardId = achievementRewardId;

        return data;
      });

      await createStep3({ achievementShop: [], achievementProduct: mapData }).then((res) => {
        getData();
      });
      setOpenProduct(!openProduct);
    };
    const handleCheckBoxDelete = (e: any, prodId: string) => {
      const checkBoxedSearch = searchProd.map((item) => ({
        ...item,
        isChecked: item.productId === prodId ? e.target.checked : item.isChecked,
      }));
      const checkBoxed = selectedProd.map((item) => ({
        ...item,
        isChecked: item.productId === prodId ? e.target.checked : item.isChecked,
      }));
      setSearchProd(checkBoxedSearch);
      setSelectedProd(checkBoxed);
    };
    const handleAllCheckBoxDelete = (e: any) => {
      const checkBoxedSearch = searchProd.map((item) => ({ ...item, isChecked: e.target.checked }));
      const mapDataSearch: any = searchProd.map((item) => {
        const matching = checkBoxedSearch.find((i) => i.productId === item.productId);
        if (matching) {
          return { ...matching, isChecked: e.target.checked };
        }
        return { ...item, isChecked: item.isChecked };
      });
      setSearchProd(mapDataSearch);

      const checkBoxed = searchProd.map((item) => ({ ...item, isChecked: e.target.checked }));
      const mapData = selectedProd.map((item) => {
        const matching = checkBoxed.find((i) => i.productId === item.productId);
        if (matching) {
          return { ...matching, isChecked: e.target.checked };
        }
        return { ...item, isChecked: item.isChecked };
      });
      setSelectedProd(mapData);
    };
    const columes = [
      {
        title: selectedProd?.length > 0 && (
          <Checkbox
            onClick={(e) => handleAllCheckBoxDelete(e)}
            checked={selectedProd.every((x) => x.isChecked)}
          />
        ),
        width: "5%",
        hidden: isEdit,
        render: (text: string, value: any) => (
          <Checkbox
            checked={value.isChecked}
            onClick={(e) => handleCheckBoxDelete(e, value.productId)}
          />
        ),
      },
      {
        title: "ชื่อสินค้า",
        dataIndex: "productName",
        key: "productName",
        render: (row: any, value: any, index: number) => {
          return {
            children: (
              <FlexRow align='center'>
                <div style={{ marginRight: 16 }}>
                  <Avatar
                    src={
                      value.productImage === "No" ||
                      value.productImage === "" ||
                      value.productImage === null
                        ? image.product_no_image
                        : value.productImage
                    }
                    size={50}
                    shape='square'
                    onError={() => false}
                  />
                </div>
                <FlexCol>
                  <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                    <Text level={5}>{value.productName}</Text>
                  </div>
                  {value.commonName && (
                    <div style={{ height: 25, textOverflow: "ellipsis" }}>
                      <Text level={6} style={{ color: color.Grey }}>
                        {value.commonName}
                      </Text>
                    </div>
                  )}
                  <div style={{ height: 25 }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      Product Group : {value.productGroup}
                    </Text>
                  </div>
                  {value.productStrategy && (
                    <div style={{ height: 25 }}>
                      <Text level={6} style={{ color: color.Grey }}>
                        Strategy Group : {value.productStrategy}
                      </Text>
                    </div>
                  )}
                </FlexCol>
              </FlexRow>
            ),
          };
        },
      },
      {
        title: "",
        dataIndex: "productCodeNAV",
        key: "productCodeNAV",
        render: (text: string, value: any) => (
          <FlexRow>
            <FlexCol>
              <div style={{ height: 25 }}>
                <Text level={5}>{text}</Text>
              </div>
              <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Pack Size : {value.packSize}
                </Text>
              </div>
            </FlexCol>
          </FlexRow>
        ),
      },
      {
        title: <span>ราคาขาย</span>,
        dataIndex: "unitPrice",
        render: (text: string, value: any) => (
          <FlexRow>
            <FlexCol>
              <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                <Text level={5}>
                  {numberFormatter(value.marketPrice)} บาท/{value.saleUOMTH}
                </Text>
              </div>
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  ราคา/หน่วย : <br />
                  {numberFormatter(text)} บาท/{value.baseUOM}
                </Text>
              </div>
            </FlexCol>
          </FlexRow>
        ),
      },
    ].filter((item) => !item.hidden);

    return (
      <div style={{ padding: "20px" }}>
        <Row justify={"space-between"} gutter={8}>
          <Col span={5}>
            <SearchInput
              placeholder='รหัส/ชื่อสินค้า'
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Col>
          <Col span={13} />
          <Col span={3}>
            <Button
              typeButton={isEdit ? "disabled" : "border-primary"}
              style={{ cursor: isEdit ? "not-allowed" : "pointer" }}
              title={"เพิ่มสินค้า"}
              icon={<PlusOutlined style={{ color: color.white }} />}
              onClick={() => !isEdit && setOpenProduct(true)}
            />
          </Col>
          <Col span={3}>
            <Button
              style={{ cursor: checkDisable ? "pointer" : "not-allowed" }}
              typeButton={checkDisable ? "danger" : "light-disabled"}
              title={"ลบสินค้า"}
              icon={<DeleteFilled color={color.white} />}
              onClick={() => checkDisable && deleteList()}
            />
          </Col>
        </Row>
        <br />
        <TableContainer>
          <Table
            loading={loading}
            pagination={false}
            columns={columes}
            dataSource={searchProd}
            scroll={{ y: 500 }}
          />
        </TableContainer>
        {openProduct && (
          <ModalSelectedProduct
            prodSelected={selectedProd}
            company={userProfile.company}
            showModalProd={openProduct}
            onClose={() => setOpenProduct(!openProduct)}
            productGroup={productGroup}
            callBackProduct={(item) => {
              callBackProduct(item);
              setOpenProduct(false);
            }}
            isDisable={true}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <div>
        <Form form={form3} layout='vertical'>
          <Row className='pb-3'>
            <Text level={4} fontWeight={700}>
              ร้านค้าและสินค้า
            </Text>
          </Row>
          <AchievementTabCardContainer>
            <Tabs
              tabBarGutter={5}
              renderTabBar={(props: any, DefaultTabBar) => {
                return (
                  <>
                    <Row justify='space-between' style={{ width: "100%" }}>
                      {props.panes.map((x, i) => {
                        const checkActive = activeTab === x.props.tabKey;
                        return (
                          <Col span={12} key={i}>
                            <div
                              style={{
                                backgroundColor: checkActive ? "white" : "#F5F7FA",
                                width: "100%",
                                height: 58,
                                borderRadius: "12px 12px 0px 0px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => setActiveTabs(x.props.tabKey)}
                            >
                              <Text
                                color={checkActive ? "primary" : "BK"}
                                fontWeight={checkActive ? 600 : 400}
                              >
                                {x.props.tab}{" "}
                                {x.props.tabKey === "SHOP" && `(${sumCount?.countShop})`}
                                {x.props.tabKey === "PRODUCT" && `(${sumCount?.countProduct})`}
                              </Text>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                    {activeTab === "SHOP" ? storeComponent() : productComponent()}
                  </>
                );
              }}
              centered
              type='card'
              items={tabList}
            />
          </AchievementTabCardContainer>
        </Form>
      </div>
    </>
  );
}
export default AchievementStep3;
